import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import dayjs from "dayjs";
import CalenderComponent from "../CalenderComponent/CalenderComponent";
import TimeRangeSelector from "../TimeRangeSelector/TimeRangeSelector";

const fallbackImage = "https://funtlers.com/static/media/booking-confirmation-img.8df3502e7365d6433146.png"; // replace if needed

export default function
    CreateActivityModal({ show, onClose, onSave, EditMode }) {
    const [showCustomActivity, setShowCustomActivity] = useState(false);
    const [customActivity, setCustomActivity] = useState({
        title: "Skriv inn ønsket tittel",
        price: "",
        kategori: " EGEN PLANLAGT AKTIVITET",
    });
    const [totalPersons, setTotalPersons] = useState(1);
    const [selectedDate, setSelectedDate] = useState(null);
    const [showCalendar, setShowCalendar] = useState(false);
    const [fromTime, setFromTime] = useState("");
    const [toTime, setToTime] = useState("");
    const [reason, setReason] = useState(null);


    const checkIsDisabled = () => {
        // Case 1: Custom activity (JA)
        if (showCustomActivity) {
            return (
                !customActivity.title.trim() ||             // title missing
                !customActivity.price || Number(customActivity.price) <= 0 || // price invalid
                !totalPersons || Number(totalPersons) <= 0 || // persons invalid
                !selectedDate ||                            // date missing
                !fromTime ||                                // from time missing
                !toTime                                    // to time missing
            );
        }

        // Case 2: Default activity (NEI)
        return (
            !totalPersons || Number(totalPersons) <= 0 || // persons invalid
            !selectedDate ||                              // date missing
            !fromTime ||                                  // from time missing
            !toTime                                      // to time missing
        );
    };



    const handleCustomActivityChange = (field, value) => {
        setCustomActivity((prev) => ({ ...prev, [field]: value }));
    };

    const totalPrice =
        customActivity.price && totalPersons
            ? Number(customActivity.price) * Number(totalPersons)
            : 0;

    const handleSave = () => {
        debugger;
        onSave({
            ...customActivity,
            totalPersons,
            date: selectedDate,
            fromTime,
            toTime,
            totalPrice,
            isCustomActivity: showCustomActivity,
            reason:reason
        });
        onClose();
    };

    return (
        <Modal centered backdrop="static" show={show} onHide={onClose}>
            <Modal.Header closeButton>
                <Modal.Title>AKTIVITETSDETALJER</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                {/* Radio buttons */}
                <div className="flex" style={{ gap: "35px", paddingBottom: "13px" }}>
                    <label className="fw-bold ">LEGG TIL EGEN AKTIVITET</label>
                    <div>
                        <label style={{ marginRight: 16 }}>
                            <input
                                type="radio"
                                name="customActivity"
                                value="nei"
                                checked={!showCustomActivity}
                                onChange={() => setShowCustomActivity(false)}
                                style={{ marginRight: 4 }}
                            />
                            NEI
                        </label>
                        <label>
                            <input
                                type="radio"
                                name="customActivity"
                                value="ja"
                                checked={showCustomActivity}
                                onChange={() => setShowCustomActivity(true)}
                                style={{ marginRight: 4 }}
                            />
                            JA
                        </label>
                    </div>
                </div>

                {/* Custom Activity Form */}
                {showCustomActivity && (
                    <div
                        className="custom-activity-form border p-3 mb-4"
                        style={{ background: "#f9f9f9", borderRadius: 8 }}
                    >
                        <div className="flex">
                            <div className="left-section-crd-custom">
                                <div className="position-relative img_otr">
                                    <img
                                        className="card_imgS card_imgS-modal"
                                        src={fallbackImage}
                                        alt="img"
                                    />
                                </div>
                            </div>

                            <div className="">
                                <div className="d-flex flex-column align-left" style={{ padding: "0px 15px" }}>
                                    <medium className="text-muted mt-2"><b>Tittel:</b></medium>
                                    <div className="d-flex flex-row">
                                        <div className="d-flex flex-column ml-1 w-100">
                                            <input
                                                className="form-control"
                                                type="text"
                                                value={customActivity.title}
                                                onChange={e => handleCustomActivityChange("title", e.target.value)}
                                                placeholder="Skriv inn tittel"
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div className="p-3">
                                    <div className="d-flex flex-row justify-content-between mid g-22">
                                        {/* Price per person */}
                                        <div className="d-flex flex-column align-left">
                                            <medium className="text-muted mt-2"><b>Pris per person:</b></medium>
                                            <div className="d-flex flex-row">
                                                <div className="d-flex flex-column ml-1">
                                                    <input
                                                        className="form-control"
                                                        type="number"
                                                        min="0"
                                                        value={customActivity.price}
                                                        onChange={(e) =>
                                                            handleCustomActivityChange("price", e.target.value)
                                                        }
                                                        onKeyDown={(e) => {
                                                            if (e.key === "-") {
                                                                e.preventDefault(); // Block minus
                                                            }
                                                        }}
                                                        onPaste={(e) => {
                                                            const pastedText = e.clipboardData.getData("Text");
                                                            if (pastedText.includes("-")) {
                                                                e.preventDefault(); // Block minus paste
                                                            }
                                                        }}
                                                        placeholder="Pris"
                                                    />
                                                </div>
                                            </div>
                                        </div>

                                        {/* Person count */}
                                        <div className="d-flex flex-column">
                                            <medium className="text-muted mt-2"><b>Antall personer:</b></medium>
                                            <div className="d-flex flex-column ml-1">
                                              
                                                <input
                                                    className="form-control"
                                                    type="number"
                                                    min="1"
                                                    value={totalPersons}
                                                    onChange={(e) => {
                                                        const val = e.target.value;
                                                        if (/^[1-9]\d*$/.test(val)) {
                                                            setTotalPersons(Number(val));
                                                        } else if (val === "") {
                                                            setTotalPersons("");
                                                        }
                                                    }}
                                                    onBlur={(e) => {
                                                        const val = e.target.value;
                                                        if (val === "" || val === "0") {
                                                            setTotalPersons(1);
                                                        }
                                                    }}
                                                    onKeyDown={(e) => {
                                                        if (["-", "e", "E", "+", "."].includes(e.key)) {
                                                            e.preventDefault();
                                                        }
                                                        if (e.key === "ArrowUp") {
                                                            setTotalPersons((prev) => Number(prev || 1) + 1);
                                                            e.preventDefault();
                                                        }
                                                        if (e.key === "ArrowDown") {
                                                            setTotalPersons((prev) =>
                                                                prev > 1 ? Number(prev) - 1 : 1
                                                            );
                                                            e.preventDefault();
                                                        }
                                                    }}
                                                    onPaste={(e) => {
                                                        const pastedText = e.clipboardData.getData("Text");
                                                        if (pastedText.includes("-")) {
                                                            e.preventDefault();
                                                        }
                                                    }}
                                                    placeholder="Antall"
                                                />

                                              
                                            </div>
                                        </div>
                                    </div>

                                    {/* Total price */}
                                    <div className="mid d-flex flex-column align-left">
                                        <medium className="text-muted mt-2"><b>Total aktivitetspris:</b></medium>
                                        <div className="d-flex flex-column ml-1">
                                            <p>{totalPrice}</p>
                                        </div>
                                    </div>

                                    {/* Date picker */}
                                    <div className="VELG-sec d-flex" style={{ alignItems: "center" }}>
                                        <medium className="text-muted mt-2" style={{ padding: "2px 7px 7px 9px" }}><b>Dato:</b></medium>
                                        <div className="w-100">
                                            <div className="ml-1">
                                                <div
                                                    style={{
                                                        cursor: "pointer",
                                                        padding: "8px 12px",
                                                        border: "1px solid #ced4da",
                                                        borderRadius: 4,
                                                        background: "#fff",
                                                        width: "100%",
                                                        color: selectedDate ? "#212529" : "#888",
                                                    }}
                                                    onClick={() => setShowCalendar(!showCalendar)}
                                                    className="dropdownCal Theme_select"
                                                >
                                                    <span>
                                                        {selectedDate
                                                            ? dayjs(selectedDate).format("YY/M/D")
                                                            : "Velg dato"}
                                                    </span>
                                                    <i className="ri-arrow-down-s-line" style={{ float: "right" }}></i>
                                                </div>
                                                {showCalendar && (
                                                    <div className="dropdown-contentCal" style={{ zIndex: 10, top: 0 }}>
                                                        <CalenderComponent
                                                            setSelectedDate={setSelectedDate}
                                                            selectedDate={selectedDate}
                                                            setShowCalender={setShowCalendar}
                                                        />
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>

                                    {/* Time selector */}
                                    <div className="VELG-sec" style={{ alignItems: "center" }}>
                                        <TimeRangeSelector
                                            labelFrom="TID"
                                            labelTo="TIL"
                                            fromTime={fromTime}
                                            toTime={toTime}
                                            setFromTime={setFromTime}
                                            setToTime={setToTime}
                                        />
                                    </div>
                                    <br/>
                                    {/* Category */}
                                    <medium className="text-muted " ><b>Kategori:</b></medium>
                                    <div className="d-flex flex-column ml-1">
                                        <div>
                                            <i className="ri-store-3-line"></i>{" "}
                                            {customActivity.kategori || "Ikke valgt"}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        { (EditMode === "isEditAdminRequest" || EditMode === "isEditBooking")
                            && (<div className="d-flex flex-column my-f mt-3 p-2">
                                <label className=" mt-2">
                                    <strong>Brukerkommentarer:</strong>
                                </label>

                                <div className="d-flex flex-column ml-1">
                                    <textarea
                                        className="form-control"
                                        rows={3}
                                        value={reason}
                                        onChange={(e) => {
                                            setReason(e.target.value);

                                        }}
                                        placeholder="Skriv en kommentar eller årsak her..."
                                    />
                                </div>
                            </div>)}
                    </div>
                )}
                {!showCustomActivity && (
                    // ✅ NEI case (default/original modal ke controllers)
                    <div className="default-activity-form border p-3 mb-4" style={{ background: "#fff", borderRadius: 8 }}>
                        {/* Yahan wahi controls rahenge jo tumhare original modal me the:
        - Date picker
        - TimeRangeSelector
        - Person count input
        - Category etc. */}
                       
                        <div className="VELG-sec d-flex" style={{ alignItems: "center" }}>
                            <span className=" mt-2" style={{ padding: "10px 56px 7px 12px", width: "96px" }}>
                                <strong>Dato:</strong>
                            </span>
                            <div className="w-100">
                                <div className="dropdownCal Theme_select"
                                    style={{
                                        cursor: "pointer",
                                        padding: "8px 12px",
                                        border: "1px solid #ced4da",
                                        borderRadius: 4,
                                        width: "100%",
                                        color: selectedDate ? "#212529" : "#888",
                                    }}
                                    onClick={() => setShowCalendar(!showCalendar)}
                                >
                                    <span>
                                        {selectedDate ? dayjs(selectedDate).format("YY/M/D") : "Velg dato"}
                                    </span>
                                    <i className="ri-arrow-down-s-line" style={{ float: "right" }}></i>
                                </div>
                                {showCalendar && (
                                    <div className="dropdown-contentCal" style={{ zIndex: 10 }}>
                                        <CalenderComponent
                                            setSelectedDate={setSelectedDate}
                                            selectedDate={selectedDate}
                                            setShowCalender={setShowCalendar}
                                        />
                                    </div>
                                )}
                            </div>
                        </div>

                        {/* Time selector */}
                        <div className="VELG-sec ">
                            <TimeRangeSelector
                                labelFrom="TID"
                                labelTo="TIL"
                                fromTime={fromTime}
                                toTime={toTime}
                                setFromTime={setFromTime}
                                setToTime={setToTime}
                            />
                        </div>

                        {/* Person count */}
                        <div className="VELG-sec w-100" style={{ display: 'inline-flex', alignItems: 'center' }}>
                            <div style={{ padding: "10px 56px 7px 12px", width: "96px" }}><strong>Antall</strong></div>
                            <div class="text input-block w-100 ">
                                <div class="input-group">

                            <button class="btn" type="button" onClick={() =>
                                totalPersons > 0
                                    ? setTotalPersons(totalPersons - 1)
                                    : setTotalPersons(totalPersons)
                            }>
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="2" viewBox="0 0 24 2">
                                    <g fill="#fff" stroke="#707070" stroke-width="1" opacity="0.45">
                                        <rect width="24" height="2" stroke="none"></rect>
                                        <rect x="0.5" y="0.5" width="23" height="1" fill="none"></rect>
                                    </g>
                                </svg>

                            </button>
                            <input
                                 className="form-control bg-transparent"
                                type="number"
                                min="1"
                                value={totalPersons}
                                onChange={(e) => {
                                    const val = e.target.value;
                                    if (/^[1-9]\d*$/.test(val)) {
                                        setTotalPersons(Number(val));
                                    } else if (val === "") {
                                        setTotalPersons("");
                                    }
                                }}
                                onBlur={(e) => {
                                    if (e.target.value === "" || e.target.value === "0") {
                                        setTotalPersons(1);
                                    }
                                }}
                                onKeyDown={(e) => {
                                    if (["-", "e", "E", "+", "."].includes(e.key)) {
                                        e.preventDefault();
                                    }
                                    if (e.key === "ArrowUp") {
                                        setTotalPersons((prev) => Number(prev || 1) + 1);
                                        e.preventDefault();
                                    }
                                    if (e.key === "ArrowDown") {
                                        setTotalPersons((prev) => (prev > 1 ? Number(prev) - 1 : 1));
                                        e.preventDefault();
                                    }
                                }}
                                onPaste={(e) => {
                                    const pastedText = e.clipboardData.getData("Text");
                                    if (pastedText.includes("-")) {
                                        e.preventDefault();
                                    }
                                }}
                                placeholder="Antall"
                            />


                            <button class="btn" type="button" onClick={() =>
                                totalPersons >= 1
                                    ? setTotalPersons(totalPersons + 1)
                                    : setTotalPersons(totalPersons)
                            }>
                                <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17">
                                    <g transform="translate(-1475.5 -614.076)">
                                        <rect width="17" height="2" transform="translate(1475.5 621.076)" fill="#707070" opacity="0.45"></rect>
                                        <rect width="17" height="2" transform="translate(1485.5 614.076) rotate(90)" fill="#707070" opacity="0.45"></rect>
                                    </g>
                                </svg>
                            </button>
                                </div>
                        </div>
                        </div>

                        { (EditMode === "isEditAdminRequest" || EditMode === "isEditBooking")
                            && (<div className="d-flex flex-column my-f mt-3 p-2">
                                <label className=" mt-2">
                                    <strong>Brukerkommentarer:</strong>
                                </label>

                                <div className="d-flex flex-column ml-1">
                                    <textarea
                                        className="form-control"
                                        rows={3}
                                        value={reason}
                                        onChange={(e) => {
                                            setReason(e.target.value);

                                        }}
                                        placeholder="Skriv en kommentar eller årsak her..."
                                    />
                                </div>
                            </div>)}


                    </div>
                ) }
            </Modal.Body>

            <Modal.Footer>
                <button className="btnOrder"
                    disabled={checkIsDisabled()}
                    onClick={handleSave}>
                    LAGRE 
                </button>
            </Modal.Footer>
        </Modal>
    );
}
